/** @format */

import { createAction, props } from '@ngrx/store';

import { AttributeOption } from '../interfaces/attributes-v2.interface';
import { AttributeSelectedActionProps } from '../interfaces/attribute-selected-action-props.interface';
import { ProductSku } from '@shared/data-access/interfaces';

export const attributeOptionsProcessed = createAction(
	'[Product State Initialization] Attribute Options Processed',
	props<{ attributeOptions: AttributeOption[][] }>()
);

export const selectAttributeOptionsUpdated = createAction(
	'[Attribute] Selected Attribute Options Updated',
	props<{
		allSelectedAttributeOptions: AttributeOption[];
		matchedSkus: ProductSku[]; // Passed through for the SKU resolution effect
	}>()
);

export const attributeValidationPerformed = createAction(
	'[Attribute] Attribute Validation Performed',
	props<{ error: { [key: string]: string }; source: string }>()
);

export const attributeSelected = createAction(
	'[Attributes] Attribute Selected',
	props<AttributeSelectedActionProps>()
);

export const stateInitAttributeSelected = createAction(
	'[Product State Initialization] Attribute Selected',
	props<AttributeSelectedActionProps>()
);

export const trueFitRecommendedSizeSelected = createAction(
	'[TrueFit] Recommended Size Selected',
	props<AttributeSelectedActionProps>()
);

export const skusFilteredForResolution = createAction(
	'[Attributes] SKUs With Selected Attribute Filtered',
	props<{
		matchedSkus: ProductSku[];
		selectedAttribute: AttributeSelectedActionProps['selectedAttribute'];
		alternativeInStockRecsEnabled?: AttributeSelectedActionProps['alternativeInStockRecsEnabled'];
	}>()
);
